(function () {
  // Wave 12 — PLP filter/sort loading grid reusing shared skeleton atoms
  // (assets/eros-shell-predictive-skeleton.css .eros-skeleton__*).
  if (window.__erosPlpSkeletonBound) return;
  window.__erosPlpSkeletonBound = true;

  var ATTR = 'data-eros-plp-skeleton';
  var CARD_COUNT = 6;
  var host = null;
  var previousHidden = null;

  function resolveList() {
    return document.querySelector('product-list.product-list[id^="product-list-"]') ||
      document.querySelector('product-list.product-list');
  }

  function buildSkeleton() {
    var root = document.createElement('div');
    root.className = 'eros-plp-skeleton';
    root.setAttribute(ATTR, '');
    root.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < CARD_COUNT; i++) {
      var card = document.createElement('div');
      card.className = 'eros-plp-skeleton__card';
      var thumb = document.createElement('div');
      thumb.className = 'eros-skeleton__thumb';
      var line1 = document.createElement('div');
      line1.className = 'eros-skeleton__line';
      var line2 = document.createElement('div');
      line2.className = 'eros-skeleton__line eros-skeleton__line--short';
      card.appendChild(thumb);
      card.appendChild(line1);
      card.appendChild(line2);
      root.appendChild(card);
    }
    return root;
  }

  function show() {
    var list = resolveList();
    if (!list || list.querySelector('[' + ATTR + ']')) return;
    host = list;
    previousHidden = [];
    Array.prototype.forEach.call(list.children, function (child) {
      previousHidden.push({ el: child, display: child.style.display });
      child.style.display = 'none';
    });
    list.appendChild(buildSkeleton());
  }

  function hide() {
    var list = host || resolveList();
    if (!list) return;
    var sk = list.querySelector('[' + ATTR + ']');
    if (sk) sk.remove();
    if (previousHidden) {
      previousHidden.forEach(function (item) {
        item.el.style.display = item.display || '';
      });
    }
    previousHidden = null;
    host = null;
  }

  // theme:loading:start/end is a theme-wide generic "something is loading"
  // signal (also fired by the LoadingBar progress indicator) — it fires for
  // every cart operation too (add-to-cart, cart-drawer quantity change,
  // quick-order-list updates), not just facet/sort AJAX. Listening to it
  // directly meant changing a cart-drawer line item's quantity while
  // sitting on a collection page hid the whole real grid behind this
  // skeleton and restored it ~600ms later — reading as "the grid reloads".
  // Confirmed live via MutationObserver: product-card style.display got
  // toggled in bulk exactly around a cart/change.js round-trip with no
  // facet action involved. Only the facets AJAX flow (theme.js
  // facets-listeners.js) is meant to trigger this skeleton, and it always
  // dispatches facet:update synchronously first — arm on that instead,
  // via a capture-phase listener so it's guaranteed to run before
  // theme.js's bubble-phase facet:update handler regardless of script
  // load order (capture always precedes bubble, unlike same-phase
  // registration order across separately-loaded scripts).
  var facetLoadPending = false;
  document.addEventListener(
    'facet:update',
    function () {
      facetLoadPending = true;
    },
    true
  );
  document.addEventListener('theme:loading:start', function () {
    if (!facetLoadPending) return;
    show();
  });
  document.addEventListener('theme:loading:end', function () {
    if (!facetLoadPending) return;
    facetLoadPending = false;
    hide();
  });
})();
